import { icons } from './constant';

// ==============================|| PRODUCT MENU ITEMS ||============================== //

const product = {
	id: 'product_master',
	title: 'Product',
	type: 'collapse',
	icon: icons.IconLoan,
	children: [
		{
			id: 'product_group',
			title: 'Product Groups',
			type: 'item',
			url: '/product-groups',
			icon: icons.Inventory2OutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'advance_emi_types',
			title: 'Advance EMI Types',
			type: 'item',
			url: '/advanceEMITypes',
			icon: icons.Inventory2OutlinedIcon,
			breadcrumbs: true,
		},
	],
};

export default product;
